// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  URL_InspeccionTotal: 'https://infinittest.vca.com.ar/api/',
  URL_Token: 'https://infinittest.vca.com.ar/auth/login',
  URL_Web: 'https://test.vca.com.ar/',

  // URL_InspeccionTotal: 'https://vehiclecheckappbackdev.azurewebsites.net/api/',
  // URL_Token: 'https://vehiclecheckappbackdev.azurewebsites.net/auth/login',

  // URL_InspeccionTotal: 'https://vehiclecheckappbacktest.azurewebsites.net/api/',
  // URL_Token: 'https://vehiclecheckappbacktest.azurewebsites.net/auth/login',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
